<div class="device-toggle-controls btn-group">
    <button
        class="btn btn-sm btn-action device-toggle-btn"
        [class.selected]="isDesktop"
        (click)="changeDeviceMode.emit(deviceMode.desktop)"
    >
        <i class="sp-icon icon-desktop"></i>
    </button>
    <button
        class="btn btn-sm btn-action device-toggle-btn"
        [class.selected]="isTablet"
        (click)="changeDeviceMode.emit(deviceMode.tablet)"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <rect
                x="2"
                y="1"
                width="12"
                height="14"
                rx="3"
                stroke="currentColor"
                stroke-width="2"
                stroke-miterlimit="10"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5 12C10.5 12.5523 10.0523 13 9.5 13L6.5 13C5.94772 13 5.5 12.5523 5.5 12C5.5 11.4477 5.94772 11 6.5 11L9.5 11C10.0523 11 10.5 11.4477 10.5 12Z"
                fill="currentColor"
            />
        </svg>
    </button>
    <button
        class="btn btn-sm btn-action device-toggle-btn"
        [class.selected]="isMobile"
        (click)="changeDeviceMode.emit(deviceMode.mobile)"
    >
        <i class="sp-icon icon-mobile"></i>
    </button>
</div>
